.footer {
  display: flex;
  justify-content: flex-end;
  margin: 6px;
  height: 20px;
}
